/*Section Header*/
function SectionHeader({ eyebrow, title }) {
  return (
    <div className="section-header">
      <div>
        <div className="section-eyebrow">{eyebrow}</div>
        <h2 className="section-title">{title}</h2>
      </div>
    </div>
  );
}

export default SectionHeader;
